import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CardInfoInactiveIcon = (props) => {
    return (_jsxs("svg", Object.assign({ width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("rect", { width: "30", height: "30", rx: "15", fill: "black" }), _jsx("path", { d: "M11.175 12.15L15 15.975L18.825 12.15L20 13.3334L15 18.3334L10 13.3334L11.175 12.15Z", fill: props.color })] })));
};
CardInfoInactiveIcon.defaultProps = {
    color: 'white',
};
export default CardInfoInactiveIcon;
